import {
  Button,
  Container,
  Fab,
  Grid,
  TextField,
  Typography,
  useScrollTrigger,
  Zoom,
} from '@mui/material';
import React, { useState, useRef, useEffect } from 'react';
import style from '../../../componentes/Tools/Style';
import {
  AddPantallasRol,
  DeletePantallasRol,
  modificarRol,
} from '../../../actions/RolesAction';
import { useStateValue } from '../../../contexto/store';
import { Link } from 'react-router-dom';
import PanelRoles from './PanelRoles';
import { obtenerUsuarioActual } from '../../../actions/UsuariosAction';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { makeStyles } from '@mui/styles';

const RolModificar = (props) => {
  const mounted = useRef(true);
  const rolprops = props.location.state;
  const [error, setError] = useState(false);
  const [{ sesionUsuario }, dispatch] = useStateValue();
  const [rol, setRol] = useState({
    Id: rolprops.Id,
    NOMBRE: '',
  });

  const ingresarValoresMemoria = (e) => {
    const { name, value } = e.target;
    setRol((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [arrManejadorPermisos, setArrManejadorPermisos] = useState([]);

  const actualizarPermisos = (permisos) => {
    setArrManejadorPermisos(permisos);
  };

  // // 🧩 FUNCIÓN UNIVERSAL PARA RECOGER TODAS LAS PANTALLAS HABILITADAS
  // const recolectarPantallas = (lista, arrHabilitar, arrDenegar) => {
  //   if (!lista || lista.length === 0) return;
  //   // 🧩 Incluir también las categorías principales si están marcadas
  //   lista.forEach((nodo) => {
  //     if (nodo.categoriaId && nodo.checked) {
  //       const obj = {
  //         id: nodo.categoriaId,
  //         nombre: nodo.nombre,
  //         ruta: nodo.ruta,
  //       };
  //       arrHabilitar.push(obj);
  //     }
  //   });

  //   lista.forEach((nodo) => {
  //     // 1️⃣ Pantallas internas (pantallasLista)
  //     if (nodo.pantallasLista && nodo.pantallasLista.length > 0) {
  //       nodo.pantallasLista.forEach((pantalla) => {
  //         const obj = {
  //           id: pantalla.pantallA_Id,
  //           nombre: pantalla.nombrepantalla,
  //           ruta: pantalla.path,
  //         };
  //         if (pantalla.checked) arrHabilitar.push(obj);
  //         else arrDenegar.push(obj);
  //       });
  //     }

  //     // 2️⃣ Subcategorías marcadas SIN pantallas internas → también cuentan
  //     if (
  //       nodo.subcategoriaId &&
  //       (!nodo.pantallasLista || nodo.pantallasLista.length === 0) &&
  //       nodo.checked
  //     ) {
  //       const obj = {
  //         id: nodo.subcategoriaId,
  //         nombre: nodo.nombre,
  //         ruta: nodo.ruta,
  //       };
  //       arrHabilitar.push(obj);
  //     }

  //     // 3️⃣ Subcategorías NO marcadas (sin pantallas internas)
  //     if (
  //       nodo.subcategoriaId &&
  //       (!nodo.pantallasLista || nodo.pantallasLista.length === 0) &&
  //       nodo.checked === false
  //     ) {
  //       const obj = {
  //         id: nodo.subcategoriaId,
  //         nombre: nodo.nombre,
  //         ruta: nodo.ruta,
  //       };
  //       arrDenegar.push(obj);
  //     }

  //     // 4️⃣ Si tiene subcategorías → recorrerlas recursivamente
  //     if (nodo.subcategoriasLista && nodo.subcategoriasLista.length > 0) {
  //       recolectarPantallas(nodo.subcategoriasLista, arrHabilitar, arrDenegar);
  //     }
  //   });
  // };
const recolectarPantallas = (lista, arrHabilitar, arrDenegar) => {
  if (!lista || lista.length === 0) return;

  lista.forEach((nodo) => {
    //  Categorías principales
    if (nodo.categoriaId && nodo.checked) {
      arrHabilitar.push({
        id: nodo.categoriaId,
        nombre: nodo.nombre,
        ruta: nodo.ruta,
      });
    }

    //  Subcategorías SIEMPRE, tengan o no pantallas hijas
    if (nodo.subcategoriaId) {
      const obj = {
        id: nodo.subcategoriaId,
        nombre: nodo.nombre,
        ruta: nodo.ruta,
      };

      if (nodo.checked) arrHabilitar.push(obj);
      else arrDenegar.push(obj);
    }

    //  Pantallas hijas
    if (nodo.pantallasLista && nodo.pantallasLista.length > 0) {
      nodo.pantallasLista.forEach((pantalla) => {
        const obj = {
          id: pantalla.pantallA_Id,
          nombre: pantalla.nombrepantalla,
          ruta: pantalla.path,
        };
        if (pantalla.checked) arrHabilitar.push(obj);
        else arrDenegar.push(obj);
      });
    }

    //  Recursividad
    if (nodo.subcategoriasLista && nodo.subcategoriasLista.length > 0) {
      recolectarPantallas(nodo.subcategoriasLista, arrHabilitar, arrDenegar);
    }
  });
};

  const actualizarRol = async (e) => {
    e.preventDefault();
    if (!rolprops.id) return;

    const rolActualizado = {
      Id: rolprops.id,
      Nombre: rol.NOMBRE,
    };

    try {
      const response = await modificarRol(rolActualizado);
      if (response.status !== 200) {
        setError(true);
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Ese nombre de Rol ya está siendo utilizado, no se actualizó',
          },
        });
        return;
      }

      let arrHabilitar = [];
      let arrDenegar = [];

      recolectarPantallas(arrManejadorPermisos, arrHabilitar, arrDenegar);

      // eliminar duplicados por ID
      arrHabilitar = arrHabilitar.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );
      arrDenegar = arrDenegar.filter(
        (v, i, a) => a.findIndex((t) => t.id === v.id) === i
      );

     
      console.table(arrHabilitar.map((x) => ({ id: x.id, nombre: x.nombre })));
const idsPantallas = arrHabilitar.map(p => p.id);

if (idsPantallas.length > 0) {
  const res = await AddPantallasRol(rolprops.id, idsPantallas);
  if (res.status !== 200) setError(true);
}


      // 🚀 Quitar pantallas deshabilitadas en paralelo
      await Promise.all(
        arrDenegar.map(async (pantalla) => {
          const res = await DeletePantallasRol(rolprops.id, pantalla.id);
          if (res.status !== 200) setError(true);
        })
      );

      if (error) {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'Ocurrieron algunos errores al actualizar, verifique el rol',
          },
        });
      } else {
        dispatch({
          type: 'OPEN_SNACKBAR',
          openMensaje: {
            open: true,
            mensaje: 'ACTUALIZADO CON ÉXITO!!!',
          },
        });
        obtenerUsuarioActual(dispatch);
        props.history.goBack();
      }
    } catch (errorCatch) {
      console.error(errorCatch);
      dispatch({
        type: 'OPEN_SNACKBAR',
        openMensaje: {
          open: true,
          mensaje: 'Error inesperado al actualizar el rol',
        },
      });
    }
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      position: 'fixed',
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  }));

  function ScrollTop(propsx) {
    const { children } = propsx;
    const classes = useStyles();
    const trigger = useScrollTrigger({
      disableHysteresis: true,
      threshold: 100,
    });

    const handleClick = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector(
        '#back-to-top-anchor'
      );
      if (anchor) {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    };

    return (
      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root}>
          {children}
        </div>
      </Zoom>
    );
  }

  return (
    <React.Fragment>
      <Container component="main" maxWidth="lg" justify="center">
        <br />
        <Typography
          align="center"
          component="h1"
          variant="h6"
          id="back-to-top-anchor"
        >
          Modificar Rol: {rolprops.name}
        </Typography>
        <br />
        <br />
        <Grid container justify="center">
          <Grid item xs={8} md={8}>
            <TextField
              name="NOMBRE"
              value={rol.NOMBRE}
              fullWidth
              onChange={ingresarValoresMemoria}
              variant="outlined"
              label="Nuevo nombre de Rol"
            />
          </Grid>
        </Grid>

        <br />
        <br />
        <Grid item lg={12}>
          <PanelRoles
            codigoRol={rolprops.id}
            actualizarPermisos={actualizarPermisos}
            procedencia="rolModificar"
          />
        </Grid>

        <br />
        <br />

        <Grid container justify="center" spacing={6}>
          <Grid item xs={4} md={4}>
            <Button
              variant="contained"
              color="primary"
              component={Link}
              to="/rol"
              style={style.submit}
            >
              Volver
            </Button>
          </Grid>

          <Grid item xs={6} md={6}>
            <Button
              variant="contained"
              color="primary"
              onClick={(e) => actualizarRol(e)}
              style={style.submit}
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </Container>

      <ScrollTop {...props}>
        <Fab color="primary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpIcon />
        </Fab>
      </ScrollTop>
    </React.Fragment>
  );
};

export default RolModificar;
